module.exports = __webpack_public_path__ + "static/media/1_A1_23.f315b55a.png";